module.exports = __webpack_public_path__ + "fonts/open-sans-v15-cyrillic-700.7b0613a.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/open-sans-v15-cyrillic-700.woff
// module id = fytF
// module chunks = 13